import React from 'react';
import { Background, ContentCtn, SlaGraphCtn, JobCount, PendingCount } from './index.style';

interface SlaProps {
  maxCount: number;
  count: number;
  children?: React.ReactChild;
  title: string;
  primaryColor: string;
  secondaryColor: string;

  // True until the real count has arrived: a pale block stands where the number will be, as on the report cards.
  pending?: boolean;
}

const SlaGraph: React.FC<SlaProps> = ({
  count,
  children,
  maxCount,
  primaryColor,
  secondaryColor,
  title,
  onClick,
  pending = false,
}): React.ReactElement => {
  return (
    <SlaGraphCtn onClick={onClick}>
      <Background secondaryColor={secondaryColor} width={pending ? 0 : (count / maxCount) * 85} />
      <ContentCtn primaryColor={primaryColor}>
        {children}
        <span>{title}</span>
      </ContentCtn>
      <JobCount>{pending ? <PendingCount aria-hidden="true" /> : count}</JobCount>
    </SlaGraphCtn>
  );
};

export default SlaGraph;
